import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus } from "lucide-react";
import { Reveal, SectionTag } from "./motion";
import { FAQ, wa } from "../lib/site";

export default function Faq() {
  const [open, setOpen] = useState(0);

  return (
    <section id="faq" className="py-24 md:py-32 bg-white" data-testid="faq-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid lg:grid-cols-5 gap-12">
        <Reveal className="lg:col-span-2">
          <SectionTag>Perguntas frequentes</SectionTag>
          <h2 className="mt-5 font-display font-extrabold tracking-tight text-3xl sm:text-4xl lg:text-5xl text-brand-deep text-balance">
            Ficou com alguma <span className="font-serif italic font-medium text-brand-light">dúvida?</span>
          </h2>
          <p className="mt-6 text-moss text-base leading-relaxed">
            Reuni aqui as perguntas que mais recebo. Se a sua não estiver aqui, me chama no WhatsApp — respondo pessoalmente.
          </p>
          <a
            href={wa("Olá, Magnus! Tenho uma dúvida sobre os passeios em Foz do Iguaçu.")}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="faq-cta-button"
            className="mt-8 inline-flex items-center gap-2 rounded-full bg-brand px-8 py-4 text-sm font-bold text-white transition-transform duration-300 hover:scale-[1.04] shadow-lg shadow-brand/25"
          >
            Tirar minha dúvida
          </a>
        </Reveal>

        <div className="lg:col-span-3 space-y-3">
          {FAQ.map((f, i) => (
            <Reveal key={f.q} delay={i * 0.05}>
              <div
                className={`rounded-2xl border transition-colors duration-300 ${open === i ? "border-brand/30 bg-sand" : "border-brand/10 bg-white"}`}
                data-testid={`faq-item-${i}`}
              >
                <button
                  onClick={() => setOpen(open === i ? -1 : i)}
                  data-testid={`faq-question-${i}`}
                  aria-expanded={open === i}
                  className="w-full flex items-center justify-between gap-4 text-left px-6 py-5"
                >
                  <span className="font-display font-bold text-base text-brand-deep">{f.q}</span>
                  <motion.span
                    animate={{ rotate: open === i ? 45 : 0 }}
                    transition={{ duration: 0.3 }}
                    className={`grid place-items-center w-8 h-8 rounded-full shrink-0 ${open === i ? "bg-brand text-white" : "bg-brand/10 text-brand"}`}
                  >
                    <Plus size={16} />
                  </motion.span>
                </button>
                <AnimatePresence initial={false}>
                  {open === i && (
                    <motion.div
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: "auto", opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
                      className="overflow-hidden"
                    >
                      <p className="px-6 pb-6 text-moss text-sm md:text-base leading-relaxed" data-testid={`faq-answer-${i}`}>
                        {f.a}
                      </p>
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
